import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import instance from '../../../request/http';
import { BASE_URL } from '../../../store/config';
import { roleStr } from '../../../common/common';
import { getObjByName } from '../../../common/utils';
import LevelChoose from '../../Components/LevelChoose';
import Participate from '../../Components/Participate';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .textWapper': {
        width: '100%',
        // height: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .textFieldF': {
            width: '100%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            width: '90px',
            marginLeft: '10px',
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
class AddMatter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            number: "",
            numberCopy: "",
            name: "",
            note: "",
            paticipant_id: "",
            case_id: "",

            userData: [],
            casesData: [],
            btnName: this.btnName(this.props.state)
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        const {
            number,
            name,
            note,
            paticipant_id,
            userData,
            case_id,
            casesData,
        } = this.state;
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.state.btnName}</Button>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{this.props.title}</div>
                <div className="line"></div>
                <div className="title">Case Info</div>
                <TextField
                    disabled={this.isMatterDisabled()}
                    id="attorney"
                    select
                    label="Case"
                    className="textField"
                    value={case_id}
                    onChange={e => this.handleSelect(e, "case_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {casesData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.number}
                        </MenuItem>
                    ))}
                </TextField>
                <div className="title">Matter Info</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="number"
                    label="Matter Number"
                    value={number}
                    onChange={e => this.handleChange(e, 'number')}
                    margin="dense"
                    variant="outlined"
                />
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="outlined-name"
                    label="Matter Name"
                    value={name}
                    onChange={e => this.handleChange(e, 'name')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Notes</div>
                <TextField
                    disabled={this.isDisabled()}
                    className="textField"
                    id="outlined-multiline-static"
                    label="Matter Notes"
                    multiline
                    rows="3"
                    value={note}
                    onChange={e => this.handleChange(e, 'note')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Originating Department / Team / Attorney</div>
                <LevelChoose
                    ref={(child) => { this.levelChoose = child }}
                    officeName={this.getHandleData("office")}
                    deptId={this.getHandleData("dept")}
                    teamId={this.getHandleData("team")}
                    memberId={this.getHandleData("member")}
                    state={this.props.state}
                    isDisabled={this.isMatterDisabled()}
                />
                <div className="title">Paticipants</div>
                {/* <TextField
                    disabled={this.isMatterDisabled()}
                    id="attorney"
                    select
                    label="Choose Paticipant"
                    className="textField"
                    value={paticipant_id}
                    onChange={e => this.handleSelect(e, "paticipant_id")}
                    margin="dense"
                    variant="outlined"
                >
                    {userData.map(option => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.office ? option.office : ""} / {this.getTeamName(option.teams)} / {option.username}
                        </MenuItem>
                    ))}
                </TextField> */}
                <Participate
                    ref={(child) => { this.participate = child }}
                    userList={[]}
                    state={null}
                />
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.getCaseList();
        this.getUsers(()=>{
            this.initData();
        });
    }
    getCaseList() {
        const { state, data } = this.props;
        let params = {
            page_index: 1,
            page_size: 1000
        }
        this.getCases(params, () => {
            if (state !== ADD) {
                if (data.case) {
                    this.setState(() => ({
                        case_id: data.case.id
                    }));
                }
            }
        });
    }
    initData() {
        const { state, data } = this.props;
        console.log(data)
        if (state === VIEW || state === EDIT) {
            const number = data.number;
            const numberCopy = data.number;
            const name = data.name;
            const note = data.note ? data.note : "";
            let paticipant_id = "";
            if (data.handler) {
                paticipant_id = data.handler.length >= 2 ? data.handler[1].user.id : "";
            }
            this.setState(() => ({
                number,
                numberCopy,
                name,
                note,
                paticipant_id,
            }))
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isMatterDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return true;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const {
            case_id,
            number,
            numberCopy,
            name,
            note,
            paticipant_id,
            userData,
        } = this.state;
        let teamObj = this.levelChoose.getData();
        const handler_id = teamObj.handler_id;
        const handler_team_id = teamObj.handler_team_id;
       
        let handlers = [];
        if (paticipant_id) {
            const paticipantObj = getObjByName(userData, "id", paticipant_id);
            handlers = [
                {
                    handler_id,
                    handler_team_id
                }, {
                    handler_id: paticipantObj.id,
                    handler_team_id: paticipantObj.teams[0].id
                }
            ]
        } else {
            handlers = [
                {
                    handler_id,
                    handler_team_id
                }
            ]
        }
        let obj = {
            case_id,
            number: (number !== numberCopy) ? number : null,
            name,
            note,
            handlers
        }
        this.props.handleCreate(obj);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //name和desc输入的内容
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    //leader和member选择的内容
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    getTeamName(teamArr) {
        if (teamArr) {
            if (teamArr.length > 0) {
                return teamArr[0].name;
            }
        }
        return "";
    }
    getHandleData(name) {
        const { data } = this.props;
        if (!data) return;
        const userObj = data.handler[0].user;
        const deptObj = data.handler[0].team;
        if (name === "office") {
            return deptObj ? deptObj.dept_info.office : "";
        } else if (name === "dept") {
            return deptObj ? deptObj.dept_info.id : "";
        } else if (name === "team") {
            return deptObj ? deptObj.id : "";
        } else if (name === "member") {
            return userObj ? userObj.id : "";
        }
    }
    //----------------request-------------------------------
    getCases(params, callback) {
        instance.get(BASE_URL + roleStr() + '/cases', { params }).then((res) => {
            const casesData = res.data.data;
            console.log(casesData)
            this.setState({
                casesData,
            }, () => {
                callback();
            });
        })
    }
    getUsers(callback) {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            let userData = res.data.data
            console.log("user", userData)
            this.setState({
                userData
            }, () => {
                callback();
            });
        })
    }
}

export default AddMatter;